import React, { useEffect, useState, useContext } from "react";
import { Card } from "@mui/material";
import { CardHeader } from "@mui/material";
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";
import QuickDate from "../../components/QuickDate";
import MDButton from "components/MDButton";
import SearchLogsReq from "../../Classes/Models/Requests/Accounting/SearchLogsReq";
import DateTimePicker from "react-datetime-picker";

const LogsSearch = ({ setSearchReq }) => {
  let req = new SearchLogsReq();
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [Id, setId] = useState();
  const [FromDate, SetFromDate] = useState(new Date());
  const [ToDate, SetToDate] = useState(new Date());
  const [UserName, setUserName] = useState();
  const [Message, setMessage] = useState();
  const [Type, setType] = useState();
  const [Request, setRequest] = useState();
  const [Response, setResponse] = useState();
  const [Route, setRoute] = useState();

  const onSearchClick = async () => {
    req.id = Id;
    req.userName = UserName;
    req.message = Message;
    req.logType = Type;
    req.request = Request;
    req.response = Response;
    req.route = Route;
    req.fromDate = FromDate;
    req.toDate = ToDate;
    if (FromDate) {
      req.fromDate = FromDate + "T00:00:00";
    }
    if (ToDate) {
      req.toDate = ToDate + "T23:59:59";
    }

    setSearchReq(req);
    console.log(req);
  };

  const onSearchNoDatesClick = async () => {
    req.id = Id;
    req.userName = UserName;
    req.message = Message;
    req.logType = Type;
    req.request = Request;
    req.response = Response;
    req.route = Route;
    setSearchReq(req);
  };

  return (
    <Card sx={{ padding: "1em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.LogsSearch}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
              marginRight: "7px",
            }}
            color="text"
            onClick={() => onSearchNoDatesClick()}
          >
            {translations.createAccountsessionSingleSessionSearchSearch}
          </MDButton>
          <MDButton
            type="button"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="text"
            onClick={() => onSearchClick()}
          >
            {translations.LogsSearchSearchwithdates}
          </MDButton>
        </div>
      </MDBox>
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-3 mt-3">
              <MDInput
                label={translations.LogsSearchLogId}
                onChange={(e) => setId(e.target.value)}
                type="number"
                sx={{ width: "100%" }}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                label={translations.LogsSearchUsername}
                className="w-100"
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                className="w-100"
                label={translations.LogsSearchMessage}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                className="w-100"
                label={translations.LogsSearchType}
                onChange={(e) => setType(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                className="w-100"
                label={translations.LogsSearchRoute}
                onChange={(e) => setRoute(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                className="w-100"
                label={translations.LogsSearchRequest}
                onChange={(e) => setRequest(e.target.value)}
                fullWidth
              />
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                className="w-100"
                label={translations.LogsSearchResponse}
                onChange={(e) => setResponse(e.target.value)}
                fullWidth
              />
            </div>

            <div className="qd col-md-5">
              <div className="quick_date_container">
                <p>{translations.PatientStayQuickDate}</p>
                <QuickDate
                  setFrom={SetFromDate}
                  setTo={SetToDate}
                  placeholder={"Quick Last Updated"}
                />
              </div>
            </div>
            <div className="qd col-md-6">
              <label>{translations.PatientStayStartDateFrom}:</label>
              <div
                className="quick_date"
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto auto", // 3 columns for the input, p, and second input
                  gap: "10px", // optional, for spacing between the columns
                  alignItems: "center", // vertically center the items
                }}
              >
                <input
                  type="date"
                  style={{
                    width: "auto",
                    ...(window.innerWidth <= 768 && { width: "100%" }),
                  }}
                  onChange={(e) => {
                    SetFromDate(e.target.value);
                  }}
                  value={FromDate}
                />

                <p>{translations.PatientStayTo}</p>

                <input
                  type="date"
                  style={{
                    width: "auto",
                    ...(window.innerWidth <= 768 && { width: "100%" }),
                  }}
                  onChange={(e) => {
                    SetToDate(e.target.value);
                  }}
                  value={ToDate}
                />
              </div>
                        
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LogsSearch;
